<template>
  <v-list>
    <v-card-text v-if="profile && bio">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm4 d-flex class="">
              <v-avatar
                size="80"
              >
                <img v-if="userpic" class="cover" :src="userpic">
              </v-avatar>
            </v-flex>
            <v-flex xs12 sm4 class="text-xs-center text-sm-left">
              <h2>{{bio.fullname}}</h2>
              <v-layout row wrap>
                <v-flex xs12 class="py-0">
                  <div class="grey--text text--darken-1">Баланс:</div>
                  <div><b>{{bio.balance}}</b> руб.</div>
                </v-flex>
                <v-flex xs12 class="py-0" v-if="bio.position">
                  <div class="grey--text text--darken-1">Класс:</div>
                  <div>{{bio.position.schoolid}} {{bio.position.name}}</div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm3 md3 style="text-align:center;">
              <small>Нажми или отсканируй:</small>
              <a :href="`https://i.ekarta43.ru?c=0000000000${bio.cardid}00000000000`" target="__blank"><v-img :src="qr"></v-img></a>
            </v-flex>
            <v-flex xs12 class="pt-3">
              <v-btn block small color="primary" outline v-if="false"
                @click="userpicDialog=true"
              >Изменить фото</v-btn>
              <userpic-crop v-model="userpicDialog" @done="updateUserpic" @cancel="userpicDialog=false">
              </userpic-crop>

              <v-btn block small color="primary" outline
                @click="pswdDialog = true"
              >Сменить пароль</v-btn>
              <v-dialog v-model="pswdDialog" persistent max-width="370" class="mx-1">
                <v-card>
                  <v-toolbar flat>
                    Сменить пароль
                    <v-spacer></v-spacer>
                    <v-btn icon flat
                      @click.native="pswdDialog=false;password=null;newpassword=null;newpassword2=null"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-text-field
                      v-model="password" type="password" label="текущий пароль"
                    ></v-text-field>
                    <v-text-field
                      v-model="newpassword" type="password" label="новый пароль"
                    ></v-text-field>
                    <v-text-field
                      v-model="newpassword2" type="password" label="новый пароль ещё раз"
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat
                    @click.native="pswdDialog=false;password=null;newpassword=null;newpassword2=null"
                    >отмена</v-btn>
                    <v-btn color="primary" flat
                    @click.native="updatePassword"
                    :disabled="validPassword === false"
                    >подтвердить</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-card-text>
    </v-card-text>
    <v-progress-linear v-else indeterminate></v-progress-linear>
  </v-list>
</template>

<script>
import UserpicCrop from '@/components/UserpicCrop'
import QRCode from 'qrcode'

export default {
  name: 'settings-bio',
  props: ['profile'],
  components: { UserpicCrop },
  data: () => ({
    bio: null,
    userpic: null,
    serv: {},
    nickDialog: false,
    pswdDialog: false,
    password: null,
    newpassword: null,
    newpassword2: null,
    userpicDialog: false,
    activeCard: null,
    qr: null
  }),
  methods: {
    async fetch () {
      const bio = this.profile
      const { balance } = await this.$store.dispatch('sioRequest', {
        topic: 'balance'
      })
      this.generateQr(this.profile.cardid)
      bio.balance = (balance / 100).toFixed(2)
      this.serv.bio = Object.assign({}, bio)
      this.bio = bio
      const { userpic } = this.profile
      this.serv.userpic = userpic
      this.userpic = userpic ||
      `https://ui-avatars.com/api/?name=${(this.profile.name || '').replace(' ', '+')}&size=128`
    },
    async updatePassword () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'person-password-update',
          pl: { oldpassword: this.password, newpassword: this.newpassword }
        })
        this.$store.dispatch('snack', meta.msg)
        this.pswdDialog = false
      } catch (err) {
        this.$store.dispatch('snack', err)
      } finally {
        this.password = null
        this.newpassword = null
        this.newpassword2 = null
      }
    },
    async updateUserpic (ev) {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'person-userpic-update',
          pl: { url: ev.url }
        })
        this.$store.dispatch('snack', meta.msg)
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async generateQr (cardid) {
      const qr = await QRCode.toDataURL(`https://i.ekarta43.ru/?c=0000000000${cardid}00000000000`)
      this.qr = qr
    }
  },
  computed: {
    validPassword () {
      if (!this.password || !this.newpassword || !this.newpassword2) return false
      if (this.newpassword !== this.newpassword2) return false
      return this.newpassword.length < 17 && this.newpassword.length > 3
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    }
  },
  async mounted () {
    if (this.profile) await this.fetch()
  }
}
</script>

<style lang="css">
.cover {
  object-fit: cover;
}
</style>
